import { Link } from "@remix-run/react";
import { RiAwardLine, RiDownloadLine } from "react-icons/ri";

import { cn } from "~/utils/classnames";

import "./CertificateCard.css";
import type { CertificateCardProps } from "./CertificateCard.types";

/**
 * Composant carte de certification.
 */
export const CertificateCard = ({ certification, className, ...props }: CertificateCardProps) => {
  return (
    <div className={cn("CertificateCard", className)} {...props}>
      <div className="CertificateCard-card">
        <RiAwardLine className="mx-auto mb-4 mt-2 size-10" />
        <div className="CertificateCard-card-texts">
          <p className="CertificateCard-card-texts-certificationType">{certification.type}</p>
          <p className="CertificateCard-card-texts-certificationName">{certification.title}</p>
        </div>
      </div>
      {certification.documents.length > 0 ? (
        <div className="flex items-center justify-center">
          <div className="mx-auto">
            {certification.documents.map((document, i) => (
              <Link
                className="CertificateCard-link"
                to={document.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                key={document.id}
              >
                <RiDownloadLine className="size-4" />
                Document {i + 1}
              </Link>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};
